// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sortable-container .sortable-list {
  height: auto !important;
  overflow: inherit !important;
}`, "",{"version":3,"sources":["webpack://./src/app/administration/policy-configurator/select-screens-modal/select-screens-modal.component.scss"],"names":[],"mappings":"AAAA;EACI,uBAAA;EACA,4BAAA;AACJ","sourcesContent":[".sortable-container .sortable-list{\r\n    height: auto !important;\r\n    overflow: inherit !important;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
